import { TimeStandard, TimezoneOffset, TimezoneOffsetText } from './constants'
import type { LocaleConfig } from './type'

enum TimezoneMY {
  KUALALUMPUR = 'Asia/Kuala_Lumpur',
}

const localeConfig: LocaleConfig = {
  helpCenterUrl: 'https://help.shopee.com.my/s/article/Aplikasi-Merchant',
  /**
   * timezone
   */
  defaultTimezone: TimezoneMY.KUALALUMPUR,
  getTimezone: (timezone?: string) => {
    const lowerTimezone = timezone?.toLowerCase()
    const config = {
      [TimezoneMY.KUALALUMPUR.toLowerCase()]: {
        timezoneStandardText: TimeStandard.WITA,
        timezoneOffset: TimezoneOffset.UTC8,
        timezoneOffsetText: TimezoneOffsetText[TimezoneOffset.UTC8],
        timezoneName: TimezoneMY.KUALALUMPUR,
      },
    }
    return config[lowerTimezone as TimezoneMY] || config[TimezoneMY.KUALALUMPUR.toLowerCase()]
  },

  currency: {
    CODE: 'MYR',
    LOCALES: 'ms-MY',
    SYMBOL: 'RM',
    MIN_FRACTION_DIGITS: 2,
    MAX_FRACTION_DIGITS: 5,
  },

  wallet: {
    availableBalanceReachAmount: 'no limit', // MY 的最低可提现金额没有限制，仅为了统一
  },

  price: {
    regExp: /^(\d+)(\.\d{0,2})?$/,
    precision: 2,
  },

  menu: {
    dish: {
      minPrice: 0.01,
      maxPrice: 10000000,
    },
  },

  order: {
    history: {
      maxDateRange: 90,
      maxDateRangeSelecting: Number.MAX_SAFE_INTEGER,
      defaultDateRangeSelecting: 7,
      maxStoreIds: 200,
    },
  },
}

export default localeConfig
